module.exports = __webpack_public_path__ + "static/media/Type_A_ground_floor.7849fcdf.jpg";